module.exports = __webpack_public_path__ + "static/media/207-Kuchen_ID_27.e73d1a79.mp3";